import * as R from 'ramda'
import {
  EquipmentGroupStId,
  Equipment,
  GroupKind,
  VASSetupFeePaidGroupDetails,
  EquipmentCategory,
  SapKey,
  EquipmentsVASSetupFeePaid
} from '../../../../types/types'
import { AssessmentResult } from './types'
// import {
//   getPaidVasSetupFee,
//   vasSetupFeeKeyHelper
// } from './../../components/Prepare/PrepareEquipment/DataGrid/utils/dataGridCommon'

interface EquipmentCounts {
  building: number
  elevator: {
    normal: number
  }
  escalator: {
    normal: number
  }
  door: {
    normal: number
  }
  resiflow: {
    normal: number
  }
}
type EquipmentCountsByGroup = Record<EquipmentGroupStId, EquipmentCounts>

export const getVasSetupFeeEquipmentSapKeyList = (_equipments: Equipment[], _equipmentCatergory: EquipmentCategory) => {
  const equipmentSapKeyList: SapKey[] = []
  // TODO fix this post implementing the offer store creation.
  // if (equipments) {
  //   equipments.forEach(equipment => {
  //     const paidSetupFee = getPaidVasSetupFee(equipment, equipmentCatergory)

  //     if (paidSetupFee.length > 0) {
  //       const getSapKeys = vasSetupFeeKeyHelper(paidSetupFee)
  //       getSapKeys.forEach(col => equipmentSapKeyList.push(col as SapKey))
  //     }
  //   })
  // }
  return equipmentSapKeyList
}

export function getVASSetupFeeEquipmentCount(assessment: AssessmentResult): VASSetupFeePaidGroupDetails[] {
  const getEquipmentVASSetupService = (
    equipments: Equipment[],
    equipmentCategory: EquipmentCategory
  ): EquipmentsVASSetupFeePaid => ({
    totalEquipment: equipments.length,
    equipmentServiceList: getVasSetupFeeEquipmentSapKeyList(equipments, equipmentCategory)
  })

  const vasSetupFeeDetails: VASSetupFeePaidGroupDetails[] = []
  switch (assessment._tag) {
    case 'ValidForFlexible':
      R.forEachObjIndexed(g => {
        const elevators = g.equipment.filter(e => e.equipmentCategory === 'elevator')
        const escalators = g.equipment.filter(e => e.equipmentCategory === 'escalator')
        vasSetupFeeDetails.push({
          groupName: g.name,
          groupId: g.groupId,
          elevator: getEquipmentVASSetupService(elevators, 'elevator'),
          escalator: getEquipmentVASSetupService(escalators, 'escalator')
        })
      }, assessment.groups)

      return vasSetupFeeDetails

    case 'ValidForFlexibleDoors':
      R.forEachObjIndexed(g => {
        const doors = g.doors.filter(e => e.equipmentCategory === 'door')
        vasSetupFeeDetails.push({
          groupName: g.name,
          groupId: g.groupId,
          door: getEquipmentVASSetupService(doors, 'door')
        })
      }, assessment.groups)
      return vasSetupFeeDetails
    case 'ValidForValueAddedServiceAddendum':
    case 'ValidForGSMCampaign': // TODO: Remove as part of GSM Clean up
    case 'ValidForQuickTender':
    case 'Invalid':
      return []
  }
}

export function getEquipmentCounts(assessment: AssessmentResult): EquipmentCountsByGroup {
  const isNormal = (e: Equipment) => e.criticality === 'normal'
  switch (assessment._tag) {
    case 'ValidForFlexible':
      return R.map(g => {
        const elevators = g.equipment.filter(e => e.equipmentCategory === 'elevator')
        const escalators = g.equipment.filter(e => e.equipmentCategory === 'escalator')
        const doors = g.equipment.filter(e => e.equipmentCategory === 'door')
        const resiflow = g.equipment.filter(e => e.equipmentCategory === 'resiflow')
        return {
          building: R.uniq(g.equipment.map(e => e.buildingId)).length,
          elevator: {
            normal: elevators.filter(isNormal).length
          },
          escalator: {
            normal: escalators.filter(isNormal).length
          },
          door: {
            normal: doors.filter(isNormal).length
          },
          resiflow: {
            normal: resiflow.filter(isNormal).length
          }
        }
      }, assessment.groups)
    case 'ValidForFlexibleDoors':
      return R.map(g => {
        const doors = g.doors.filter(e => e.equipmentCategory === 'door')
        return {
          building: R.uniq(g.doors.map(e => e.buildingId)).length,
          elevator: {
            normal: 0
          },
          escalator: {
            normal: 0
          },
          door: {
            normal: doors.filter(isNormal).length
          },
          resiflow: {
            normal: 0
          }
        }
      }, assessment.groups)
    case 'ValidForQuickTender':
    case 'ValidForValueAddedServiceAddendum':
    case 'ValidForGSMCampaign': // TODO: Remove as part of GSM Clean up
      return R.map(
        g => ({
          building: R.uniq(g && g.elevators ? g.elevators.map(e => e.buildingId) : []).length || 0,
          elevator: {
            normal: g.elevators ? g.elevators.length : 0
          },
          escalator: {
            normal: 0
          },
          door: {
            normal: 0
          },
          resiflow: {
            normal: 0
          }
        }),
        assessment.groups
      )
    case 'Invalid':
      return {}
  }
}

export interface Group {
  readonly groupId: EquipmentGroupStId
  readonly name: string
  readonly groupKind: GroupKind
  readonly equipment: Equipment[]
}

export function collectGroups(assessment: AssessmentResult): Group[] {
  switch (assessment._tag) {
    case 'ValidForFlexible':
      return R.values(assessment.groups)
    case 'ValidForFlexibleDoors':
      return R.map(g => ({ ...g, equipment: g.doors }), R.values(assessment.groups))
    case 'ValidForQuickTender':
    case 'ValidForValueAddedServiceAddendum':
    case 'ValidForGSMCampaign': // TODO: Remove as part of GSM Clean up
      return R.map(
        g => ({
          ...g,
          equipment: g.elevators
        }),
        R.values(assessment.groups)
      )
    case 'Invalid':
      return []
  }
}
